export default "__VITE_ASSET__DQfKkOPa__"